import React, { useState } from 'react';
import Link from 'shared/SlashLink';
import './SameDayPromo.css';

// Animated floating feature button promoting Same Day Websites.
// Dismissible for the session so it doesn't nag returning visitors.
const SameDayPromo = () => {
    const [hidden, setHidden] = useState(() => {
        try { return sessionStorage.getItem('sdwPromoDismissed') === '1'; }
        catch { return false; }
    });

    if (hidden) return null;

    const dismiss = (e) => {
        e.preventDefault();
        e.stopPropagation();
        try { sessionStorage.setItem('sdwPromoDismissed', '1'); } catch (err) { /* ignore */ }
        setHidden(true);
    };

    return (
        <Link
            to="/same-day-websites"
            className="sdw-promo"
            onClick={() => window.scrollTo(10, 0)}
            aria-label="Same Day Websites — your site live in 24 hours"
        >
            <button type="button" className="sdw-promo-close" onClick={dismiss} aria-label="Dismiss">
                <i className="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
            <span className="sdw-promo-icon">
                <i className="fa-solid fa-bolt" aria-hidden="true"></i>
            </span>
            <span className="sdw-promo-text">
                <span className="sdw-promo-sub">Live in 24 hours</span>
                <span className="sdw-promo-title">Same Day Websites</span>
            </span>
            <span className="sdw-promo-arrow">
                <i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i>
            </span>
        </Link>
    );
};

export default SameDayPromo;
